import * as React from 'react';


export class PDTagEditor_Help extends React.Component {
    render() {
        return (
            <p>The tagging help system is under development.</p>
        );
    }
}
